// extracted by mini-css-extract-plugin
export var bullets = "SectionAlternateGrid3-module--bullets--9ea15";
export var gridContainer = "SectionAlternateGrid3-module--gridContainer--f73e7";
export var icon = "SectionAlternateGrid3-module--icon--63e9c";
export var imgContainer = "SectionAlternateGrid3-module--imgContainer--5bb73";
export var sourceText = "SectionAlternateGrid3-module--sourceText--f3f98";
export var statement = "SectionAlternateGrid3-module--statement--4049a";
export var title = "SectionAlternateGrid3-module--title--375c5";
export var txtContainer = "SectionAlternateGrid3-module--txtContainer--9a5e3";